import { shallowMount } from "@vue/test-utils";
import TimeRange from "@/components/core/composite/combos/TimeRange";

describe("TimeRange component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(TimeRange);
  });

  it("Renders del component TimeRange", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
